import { Component, OnInit, HostListener } from '@angular/core';
import { faChartBar,faFileUpload,faAddressCard,faLock } from '@fortawesome/free-solid-svg-icons';
import { AuthService } from "src/app/services/auth.service";
import { BoardService } from "src/app/services/board.service";
import { OwlOptions } from 'ngx-owl-carousel-o';
import { Router, NavigationEnd } from "@angular/router";
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-board',
  templateUrl: './board.component.html',
  styleUrls: ['./board.component.css']
})
export class BoardComponent implements OnInit {
  debugger
  destroy$: Subject<boolean> = new Subject<boolean>();
  sliderRtl = true;
  constructor(
    private router:Router,
    private auth:AuthService,
    private BoardService:BoardService,
    public translate: TranslateService,
  ) {
    router.events.forEach((event) => {
      if(event instanceof NavigationEnd && event.urlAfterRedirects == '/board/main') {
        this.getCounts();
      }
    });
   }
  links=[
    {text:'الصفحة الرئيسية', icon:faChartBar, routerLink:'main', routerLinkActive:'active'},
    {text:'تقديم طلب', icon:faFileUpload, routerLink:'addrequest', routerLinkActive:'active'},
    {text:'الملف الشخصي', icon:faAddressCard, routerLink:'profile', routerLinkActive:'active'},
    {text:'تغيير كلمة المرور', icon:faLock, routerLink:'password', routerLinkActive:'active'},
  ];

  customOptions: OwlOptions;

  cards=[
    {id:1,icon:'plus.svg', backgroundClass:'blue-bg', numberColor:'blue-color', text:'الطلبات', text2:'الاجمالي', number:0},
    {id:2,icon:'check.svg', backgroundClass:'green-bg', numberColor:'green-color', text:'طلبات', text2:'مقبولة', number:0},
    {id:3,icon:'clock.svg', backgroundClass:'yellow-bg', numberColor:'yellow-color', text:'طلبات', text2:'مؤقتة', number:0},
    {id:4,icon:'false.svg', backgroundClass:'red-bg', numberColor:'red-color', text:'طلبات', text2:'مرفوضة', number:0},
  ];
  smallScreen=false;

  ngOnInit() {
    this.debugger
    if(localStorage.getItem('lang') != 'ar'){
      this.sliderRtl = false;
    }
    // Slider
    this.customOptions = {
      rtl:this.sliderRtl,
      mouseDrag: true,
      touchDrag: false,
      pullDrag: false,
      dots: true,
      navSpeed: 700,
      responsive: {
        0: {
          items: 1
        },
        445: {
          items: 2
        },
        665: {
          items: 3
        },
        930: {
          items: 4
        }
      },
      nav: false
    }

    this.isSmallScreen();
    this.getCounts();
    this.getSidebarLinks();
    this.getCountsLabels();
    this.BoardService.getNotificate()
    .pipe(takeUntil(this.destroy$))
    .subscribe(data=>{
      this.getCounts();
    })
  }

  ngOnDestroy() {
    this.destroy$.next(true);
    // Now let's also unsubscribe from the subject itself:
    this.destroy$.unsubscribe();
  }

  getCounts(){
    this.BoardService.GetDashboardDataCounts()
    .pipe(takeUntil(this.destroy$))
    .subscribe(data=>{
      let res = data.result;
      this.cards[0].number = res.totalRequests;
      this.cards[1].number = res.acceptedRequests;
      this.cards[2].number = res.delayedRequests;
      this.cards[3].number = res.refusedRequests;
    })
  }

  getSidebarLinks(){
    this.debugger
    this.translate.get('Board.Sidebar')
    .pipe(takeUntil(this.destroy$))
    .subscribe(data=>{      
      this.links[0].text = data.home;
      this.links[1].text = data.addRequest;
      this.links[2].text = data.profile;
      this.links[3].text = data.changePassword;
    })
  }

  getCountsLabels(){
    this.translate.get('Board.Counts')
    .pipe(takeUntil(this.destroy$))
    .subscribe(data=>{      
      this.cards.map(x=>{
        x.text = data.requests;
      })
      this.cards[0].text2 = data.total;
      this.cards[1].text2 = data.accepted;
      this.cards[2].text2 = data.temporary;
      this.cards[3].text2 = data.rejected;
    })
  }

  @HostListener('window:resize', [])
  onResize() {
    this.isSmallScreen()
  }

  isSmallScreen() {
    if (window.innerWidth < 840) {
        this.smallScreen =  true;
    } else {
      this.smallScreen = false;
    }
  }

  Logout(){
    this.auth.Logout();
 //   this.router.navigate(['home']);
   // window.location.href = "https://stg-id.uaepass.ae/idshub/logout?redirect_uri=http://localhost:4200/"
    //window.location.href = "https://stg-id.uaepass.ae/idshub/logout?redirect_uri=https://stagingaid.fujcharity.ae/"
    window.location.href = "https://id.uaepass.ae/idshub/logout?redirect_uri=https://aid.fujcharity.ae/"
  }

}
